import { Link } from "react-router-dom";
import { INSTAGRAM_URL, EMAIL, P_IVA, CLIENT_AREA_URL, openPrivacy } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="py-14">
      <div className="mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8">
        <p className="section-kicker">Servizi in Sicilia</p>
        <div className="mt-4 flex flex-col gap-1 text-sm sm:flex-row sm:gap-8">
          <Link data-testid="footer-link-fotografo" to="/fotografo-strutture-ricettive-sicilia" className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Fotografo per strutture ricettive
          </Link>
          <Link data-testid="footer-link-commercialista" to="/commercialista-affitti-brevi-sicilia" className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Commercialista affitti brevi
          </Link>
          <Link data-testid="footer-link-aprire-bb" to="/aprire-struttura-ricettiva-sicilia" className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Aprire una struttura ricettiva
          </Link>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-4 sm:px-6 lg:flex-row lg:items-end lg:justify-between lg:px-8">
        <div>
          <div className="flex items-baseline gap-1.5">
            <span className="font-heading text-3xl font-black uppercase tracking-tight text-[#FAF7F2]">YU</span>
            <span className="font-heading text-lg font-black uppercase tracking-tight text-[#E05A2C]">YieldUp</span>
          </div>
          <p className="mt-3 text-sm text-[#A89F91]">Revenue management, un proprietario alla volta.</p>
        </div>
        <div className="flex flex-col gap-1 text-sm sm:flex-row sm:items-center sm:gap-10">
          <a data-testid="footer-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Instagram
          </a>
          <a data-testid="footer-client-area-link" href={CLIENT_AREA_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Area Clienti
          </a>
          <button data-testid="footer-privacy-link" onClick={openPrivacy} className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            Privacy
          </button>
          <a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="inline-flex min-h-[44px] items-center text-[#C4BBB0] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#E05A2C] sm:min-h-0">
            {EMAIL}
          </a>
          {P_IVA && <span data-testid="footer-piva" className="font-mono text-xs uppercase tracking-widest text-[#A89F91]">{P_IVA}</span>}
        </div>
      </div>
    </footer>
  );
}
